module.exports = __webpack_public_path__ + "936a6e4a5031665a7397ad32a1cd3c61.svg";